
import happyKidsHomepageQuery from '@/apollo/queries/happy-kids/happyKidsHomepage';
import pageMeta from '~/mixins/pageMeta.js';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFamilySiteFnMixins from '~/mixins/eventTrackingFamilySiteFnMixins.js';
import eventTrackingFamilySiteProductCardsMixins from '~/mixins/eventTrackingFamilySiteProductCardsMixins.js';

export default {
  name: 'IndexPage',

  mixins: [pageMeta, eventTrackingMixins, eventTrackingFamilySiteFnMixins, eventTrackingFamilySiteProductCardsMixins],

  data() {
    return {
      homepage: Object,
      loading: 0,
      pageData: null,

      absolute: true,
      opacity: 0.5,
      overlay: false,
    };
  },

  apollo: {
    $loadingKey: 'loading',
    pageData: {
      prefetch: true,
      query: happyKidsHomepageQuery,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale), year: '2024' };
      },
      update(data) {
        return this.$normalizeStrapi(data.familyCampaignHomepages.data[0]);
      },
    },
  },

  watch: {
    $route(to, from) {
        const that = this;
        this.$nextTick(() => {
          this.eventTrackingListenersForFamilySite(),
          this.checkProductCardImpression()
        });
    }
  },


  methods: {
    openVideo(youtubeEmbedLink) {
      // console.log('openVideo()...', youtubeEmbedLink)
      this.$store.commit('modal/setVideoModalLink', youtubeEmbedLink);
      this.$store.commit('modal/setShowVideoModal', true);
    },
  },


};
